import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from 'material-ui';

import './utilityInputs.css';
import '../../../grid.css';
import Btn from '../../../components/Btn';
import MonthlykWhInputs from './MonthlykWhInputs';
import MonthlyFixedInputs from './MonthlyFixedInputs';
import AnnualkWhInput from './AnnualkWhInput';
import AnnualFixedChargeInput from './AnnualFixedChargeInput';
import { formattedNumber } from '../../../utils/formatterHelpers';
import UtilityList from './UtilityList';

class UtilityInputs extends Component {
    static defaultProp = {
        provider: null,
    };

    toggleUtilityInput() {
        const { setUtilityInputsIsVisible, isVisible } = this.props;
        setUtilityInputsIsVisible(!isVisible);
    }

    handleEnergyValueChange(value) {
        const { setUtilityEnergyValue } = this.props;
        setUtilityEnergyValue(value);
    }

    handleUtilityChange(value) {
        const { setUtilityProvider } = this.props;
        setUtilityProvider(Number(value));
    }

    handleInflationChange(value) {
        const { setUtilityAnnualInflation } = this.props;
        setUtilityAnnualInflation(Number(value));
    }

    handleAnnualFixedChange(value) {
        const { setAFixedCharge } = this.props;
        setAFixedCharge(Number(value));
    }

    toggleAnnualMonth() {
        const { toggleAnnualMonth, annualMonth } = this.props;
        toggleAnnualMonth(!annualMonth);
    }

    render() {
        const {
            annualInflation,
            energyValue,
            isLocked,
            isVisible,
            annualMonth,
            totalkWhs,
            totalFixed,
        } = this.props;

        return (
            <div>
                <Btn label="Utility" onClick={() => this.toggleUtilityInput()} />
                {isVisible ? (
                    <div>
                        <div className="row">
                            <div className="col span-1-of-4">
                                <UtilityList />
                            </div>
                            <div className="col span-1-of-4">
                                <TextField
                                    onChange={(e, value) => this.handleEnergyValueChange(value)}
                                    disabled={isLocked}
                                    defaultValue={energyValue}
                                    hintText="$0.15"
                                    floatingLabelText="Utility Rate W/ Demand per kWh"
                                />
                            </div>
                            <div className="col span-1-of-4">
                                <TextField
                                    onChange={(e, value) => this.handleInflationChange(value)}
                                    disabled={isLocked}
                                    defaultValue={annualInflation}
                                    hintText="2.00%"
                                    floatingLabelText="Utility Annual Inflation (%)"
                                />
                            </div>
                        </div>
                        <div className="row">
                            {annualMonth === true ? (
                                <div>
                                    <div className="col span-2-of-4">
                                        <h3 className="h3InputTitle">Annual Consumption</h3>
                                        <AnnualkWhInput />
                                    </div>
                                    <div className="col span-2-of-4">
                                        <h3 className="h3InputTitle">Annual Fixed Charge</h3>
                                        <AnnualFixedChargeInput />
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <h3 className="h3InputTitle">Monthly Consumption</h3>
                                    <h1>{formattedNumber(totalkWhs)} kWh</h1>
                                    <MonthlykWhInputs />
                                    <h3 className="h3InputTitle">Monthly Fixed Charges</h3>
                                    <h1>$ {formattedNumber(totalFixed)}</h1>
                                    <MonthlyFixedInputs />
                                </div>
                            )}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

UtilityInputs.propTypes = {
    annualInflation: PropTypes.number.isRequired,
    isVisible: PropTypes.bool.isRequired,
    energyValue: PropTypes.number.isRequired,
    isLocked: PropTypes.bool.isRequired,
    setUtilityAnnualInflation: PropTypes.func.isRequired,
    setUtilityEnergyValue: PropTypes.func.isRequired,
    setUtilityInputsIsVisible: PropTypes.func.isRequired,
    setUtilityProvider: PropTypes.func.isRequired,
    setAFixedCharge: PropTypes.func,
    annualMonth: PropTypes.bool.isRequired,
    toggleAnnualMonth: PropTypes.func.isRequired,
    totalkWhs: PropTypes.number.isRequired,
    totalFixed: PropTypes.number.isRequired,
};

UtilityInputs.defaultProps = {
    setAFixedCharge: null,
};

export default UtilityInputs;



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/UtilityInputs.js